/**
 * CSV Export Utility
 *
 * Shared helper for downloading data as CSV files.
 * Consolidated from GrowthPage, VoortgangPage, ReportsPage (D-SCAN D-6).
 */

/**
 * Trigger a CSV file download in the browser.
 *
 * @param content - The CSV string content
 * @param filenamePrefix - Prefix for the filename (date is appended automatically)
 */
export function downloadCsv(content: string, filenamePrefix: string): void {
  const blob = new Blob([content], {
    type: 'text/csv;charset=utf-8;',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute(
    'download',
    `${filenamePrefix}_${new Date().toISOString().split('T')[0]}.csv`,
  )
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
